import { ArrowLeftOutline } from '../../utils/editorReactIcons';
export { ArrowLeftOutline };
export default ArrowLeftOutline;
